import {Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Router} from '@angular/router';
import {PromotionSettingsComponent} from '../promotion-settings/promotion-settings.component';
import {MatDialog} from '@angular/material';

export interface NavItem {
    displayName: string;
    disabled?: boolean;
    iconName: string;
    route?: string;
    select: boolean;
    override: boolean;
    index: number;
    children?: NavItem[];
}

@Component({
    selector: 'app-api-dependency-menu',
    templateUrl: './api-dependency-menu.component.html',
    styleUrls: ['./api-dependency-menu.component.scss'],
    animations: [
        trigger('indicatorRotate', [
            state('collapsed', style({transform: 'rotate(0deg)'})),
            state('expanded', style({transform: 'rotate(180deg)'})),
            transition('expanded <=> collapsed',
                animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
            ),
        ])
    ]
})
export class ApiDependencyMenuComponent implements OnInit, OnChanges {

    @Input() expanded: boolean;
    @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
    @Input() navItems: any;
    @Input() depth: number;
    @Input() expandChildren = false;
    @Input() apiDependenciesList: any;
    @Input() targetDatabases: any;
    @Input() apiDeploymentStatus: any;
    @Input() isParent = false;
    @Output() itemSelected: EventEmitter<any> = new EventEmitter<any>();
    @Output() allCompleted: EventEmitter<any> = new EventEmitter<any>();
    @Output() showLogs: EventEmitter<any> = new EventEmitter<any>();
    @Output() permissionObject: EventEmitter<any> = new EventEmitter<any>();

    item: NavItem;


        // constructor(public navService: NavService,
    //             public router: Router) {
    //   if (this.depth === undefined) {
    //     this.depth = 0;
    //   }
    // }

    constructor(public router: Router, private dialog: MatDialog) {
        if (this.depth === undefined) {
            this.depth = 0;
        }
        this.expanded = false;
        this.ariaExpanded = this.expanded;
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.item = this.navItems[0];
    }

    ngOnInit() {
        // this.navService.currentUrl.subscribe((url: string) => {
        //   if (this.item.route && url) {
        //     this.expanded = url.indexOf(`/${this.item.route}`) === 0;
        //     this.ariaExpanded = this.expanded;
        //   }
        // });
        this.item = this.navItems[0];
    }

    // ngOnChanges(changes: SimpleChanges) {
    //     for (const propName in changes) {
    //         if (propName === 'apiDeploymentStatus') {
    //         }
    //     }
    // }

    onItemSelected(index) {
        // if (!item.children || !item.children.length) {
        //   this.router.navigate([item.route]);
        //   this.navService.closeNav();
        // }
        this.itemSelected.emit(index);
    }

    toggleItem(item) {
        if (item.children && item.children.length) {
            this.expanded = !this.expanded;
        }
    }

    expandAll() {
        this.expanded = true;
        this.expandChildren = true;
    }

    collapseAll() {
        this.expanded = false;
        this.expandChildren = false;
    }

    updateAllComplete(itemObj) {
        this.allCompleted.emit(itemObj);
    }

    updatePermissionObject (itemObj) {
        this.permissionObject.emit(itemObj);
    }

    configurePromotionSettings(itemObj) {
        const dialogRef = this.dialog.open(PromotionSettingsComponent, {
            height: '75%',
            width: '60%',
            data: {
                type: 'individual',
                users: JSON.parse(JSON.stringify(itemObj.users)),
                navItems: JSON.parse(JSON.stringify(this.navItems)),
            }
        });

        dialogRef.afterClosed().subscribe(async result => {
            if (result === 'configure') {
                itemObj.users = JSON.parse(JSON.stringify(dialogRef.componentInstance.users));
                this.permissionObject.emit(itemObj);
            }
        });
    }

    showLog(val) {
        this.showLogs.emit(val);
    }
}
